import { faCircleCheck, faCircleXmark, faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, Col, Container, Form, Modal, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import * as Common from "../Common";
import Dialog from '../Dialog';
import Dialog_IRN from '../Dialog_IRN';
import DialogYesNo from '../Dialog_Yes_No';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from "../Picklist";
import Tran_data_unlock_request from '../Tran_data_unlock_request';
import Tran_date_change_modal from './Tran_date_change_modal';
import Tran_stock_modal from './Tran_stock_modal';
import CancelDialog from '../CancelDialog';

function Tran_sb() {

    const sid = sessionStorage.getItem("sessionId");
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");
    const branchDisable = sessionStorage.getItem('branchDisable');
    const isdRef = useRef();

    const navigate = useNavigate();
    const [userRight, setUserRight] = useState([]);
    const [key, setKey] = useState("INFO");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [radioType, setRadioType] = useState("N");
    const [scrMode, setScrMode] = useState("");
    const [hdrSrno, setHdrSrno] = useState(0);

    const [sbLocation, setSBLocation] = useState(null);
    const [sbLocationValue, setSBLocationValue] = useState(0);
    const [sbDealer, setSBDealer] = useState(null);
    const [sbFromDate, setSBFromDate] = useState(new Date());
    const [sbToDate, setSBToDate] = useState(new Date());
    const [sbNewDate, setSBNewDate] = useState(new Date());
    const [sbSrnoFrom, setSBSrnoFrom] = useState("");
    const [sbSrnoTo, setSBSrnoTo] = useState("");
    const [sbStateValue, setSBStateValue] = useState(0);
    const [sbStateName, setSBStateName] = useState("");
    const [sbStateType, setSBStateType] = useState(0);
    const [disableOtherCharge, setDisableOtherCharge] = useState(true);

    const [productList, setProductList] = useState([]);
    const [pProduct, setPProduct] = useState("CN");
    const [pIsd, setPIsd] = useState(null);
    const [pDenomination, setPDenomination] = useState("");
    const [pQuantity, setPQuantity] = useState("");
    const [commission, setCommission] = useState("");
    const [isCommission, setIsCommission] = useState("0");
    const [commType, setCommType] = useState("F");
    const [commValue, setCommValue] = useState("");
    const [pRate, setPRate] = useState("");
    const [pIsdId, setPIsdId] = useState(null);
    const [pAgent, setPAgent] = useState(null);
    const [counter, setCounter] = useState(0);
    const [productLineNo, setProductLineNo] = useState(0);
    const [maxPRate, setMaxPRate] = useState(0);
    const [minPRate, setMinPRate] = useState(0);

    const [pdAccount, setPdAccount] = useState(null);
    const [pdPaymentType, setPdPaymentType] = useState("");
    const [pdAmount, setPdAmount] = useState("");
    const [pdChequeNum, setPdChequeNum] = useState("");
    const [paymentData, setPaymentData] = useState([]);
    const [chequeBankName, setChequeBankName] = useState("");
    const [chequeDate, setChequeDate] = useState(null);
    const [ldgSrchType, setLdgSrchType] = useState("");
    const [paymentLineNo, setPaymentLineNo] = useState(0);

    const [pOtherCharges, setPOtherCharges] = useState(0);
    const [pTotalAmount, setPTotalAmount] = useState(0);
    const [pCgst, setPCgst] = useState(0);
    const [pSgst, setPSgst] = useState(0);
    const [pIgst, setPIgst] = useState(0);
    const [pUgst, setPUgst] = useState(0);
    const [pForexTotal, setPForexTotal] = useState(0);
    const [pRoundOff, setPRoundOff] = useState(0);
    const [pTaxableVal, setPTaxableVal] = useState(0);

    const [nDealer, setNDealer] = useState(null);
    const [nState, setNState] = useState({ value: 0, label: "Select" });
    const [nMode, setNMode] = useState("B");
    const [nExecutive, setNExecutive] = useState(null);
    const [nTranType, setNTranType] = useState("AF");
    const [randomString, setRandomString] = useState("");

    const [sbList, setSBList] = useState([]);
    const [hdrDate, setHdrDate] = useState(null);
    const [hdrLocation, setHdrLocation] = useState("");


    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);
    const [usdRate, setUsdRate] = useState(0);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);

    const [showCommissionDetail, setShowCommissionDetail] = useState(false);

    const [isMsgBoxCancelBill, setMsgBoxCancelBill] = useState(false);
    const [msgTextCancelBill, setMsgTextCancelBill] = useState("");
    const [irnCancelReason, setIrnCancelReason] = useState("");
    const [irnCancelLabel, setIrnCancelLabel] = useState("");
    const [irnCancelDeclaration, setIrnCancelDeclaration] = useState(false);

    const [corpServiceCharge, setCorpServiceCharge] = useState(0);
    const [hdrDateYmd, setHdrDateYmd] = useState("");
    const [isIrnGenerated, setIsIrnGenerated] = useState("0");
    const [irnObj, setIrnObj] = useState({ irn: "", ackdate: "", acknum: "", signedqr: "" });
    const [isIrnCancelled, setIsIrnCancelled] = useState("0");
    const [irnCancelDate, setIrnCancelDate] = useState("");
    const [isIrnApplicable, setIsIrnApplicable] = useState("N");
    const [irnCancelReasonHdr, setIrnCancelReasonHdr] = useState("");

    const [irnCancelReasonSelect, setIrnCancelReasonSelect] = useState("");
    const [irnCancelRemarkHdr, setIrnCancelRemarkHdr] = useState("");

    const [viewDate, setViewDate] = useState("");
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState("");

    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [pdRemark, setPdRemark] = useState("");
    const [nRemark1, setNRemark1] = useState("");
    const [nRemark2, setNRemark2] = useState("");
    const [compareData, setCompareData] = useState([]);
    const [showMinMaxRateModal, setShowMinMaxRateModal] = useState(false);
    const [minMaxRate, setMinMaxRate] = useState([]);
    const [disablePaymentAccount, setDisablePaymentAccount] = useState(true);
    const [nManualno, setNManualno] = useState(null);

    const [openDateChangeModal, setOpenDateChangeModal] = useState(false);
    const [changeDateObj, setChangeDateObj] = useState({});

    const [showStockModal, setShowStockModal] = useState(false);
    const [stockObj, setStockObj] = useState({});
    const [dateChangeRight, setDateChangeRight] = useState();


    const [userCancelBillRight, setUserCancelBillRight] = useState([]);
    const [msgBoxYNBillDelete, setMsgBoxYNBillDelete] = useState(false);
    const [msgTextYNBillDelete, setMsgTextYNBillDelete] = useState("");

    const [acRemark, setAcRemark] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [riskValue, setRiskValue] = useState("0");
    const [riskModalBoxText, setRiskModalBoxText] = useState("");
    const [cancelButtonView, setCancelButtonView] = useState(true);
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("")

    const [dealerName, setDealerName] = useState("");
    const [dealerPan, setDealerPan] = useState("");
    const [dealerAddress, setDealerAddress] = useState("");
    const [dealerGsitn, setDealerGstin] = useState("");

    const [agentName, setAgentName] = useState("");
    const [agentAddress, setAgentAddress] = useState("");
    const [agentPan, setAgentPan] = useState("");
    const [trandate, setTrandate] = useState(null);

    useEffect(() => {
        if (sessionStorage.getItem("activeBranch") == Common.HoCode) {
            sessionStorage.activeBranch = sessionStorage.getItem('activeBranchWithoutHo');
        }
        Common.getActiveBranch().then(response => {
            setSBLocation(response);
            response != null && handleLocationChange(response);
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_SB'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });
        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_DELETE_BILL'], function (result) {
            let resp = JSON.parse(result);
            if (+resp.query === 1) {
                setUserCancelBillRight(resp);
            }
        });
        // Common.callApi(Common.apiIsd, [sid, "ddlistjsonselect", 'CN'], result => {
        //   setIsdOptions(JSON.parse(result));
        // });
        // Common.callApi(Common.apiResidentialStatus, [sid, "listResidential"], result => {
        //   setResidentOptions(JSON.parse(result));
        // });
        // Common.callApi(Common.apiState, [sid, "getState", 1], result => {
        //   setStateOptions(JSON.parse(result));
        // });
        Common.getDateChangeRight(sid, setDateChangeRight);//get right to change date
    }, []);


    const handleLocationChange = (value) => {
        setSBLocation(value);
        var id = value.id;
        var location = id.split("^");
        setSBLocationValue(location[1]);
        setSBStateValue(location[3] == null ? 0 : location[3]);
        setSBStateType(location[4]);
        setSBStateName(location[5] === "" ? "Select" : location[5]);

        setHdrLocation(location[2]);
        setIsBranchDisableForAddNew(location[9]);
        sessionStorage.activeBranch = location[1];
    }

    const handleDealerChange = (value) => {
        setSBDealer(value);
        var id = value.id;
        var corp = id.split("^");
        setNState({ value: corp[3], label: corp[4] });
        if (corp[8] > 0) otherChargeChange(corp[8]);
        setCorpServiceCharge(corp[8] == "" ? 0 : corp[8]);
    }

    const handleExecutiveChange = (value) => {
        setNExecutive(value);
    }

    const otherChargeChange = (v) => {
        const obj = {
            tranType: "SB",
            type: "SALE",
            nState: nState.value,
            pOtherCharges: v === "" ? 0 : v.trim(),
            ppStateType: sbStateType,
            ppStateValue: sbStateValue
        }
        Common.validateDecValue(v, setPOtherCharges);
        if (Common.isPurelyNumeric(v)) {
            calcInvoice(productList, obj);
        }
    }

    const listSBdata = () => {
        var msg = [], i = 0;
        $(".loader").show();

        if (sbLocation === null || (radioType === 'S' && !sbSrnoFrom) || (radioType === 'S' && !sbSrnoTo) || (radioType === 'D' && !sbFromDate) ||
            (radioType === 'D' && !sbToDate) || (radioType === 'I' && sbDealer === null) || (radioType === 'I' && !sbFromDate) || (radioType === 'I' && !sbToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (sbLocation === null ? " Location." : '');
            msg[i++] = (radioType === 'S' && !sbSrnoFrom ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && !sbSrnoTo ? " To Srno." : '');
            msg[i++] = (radioType === 'D' && !sbFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !sbToDate ? " To Date." : '');
            msg[i++] = (radioType === 'I' && sbDealer === null ? " Dealer." : '');
            msg[i++] = (radioType === 'I' && !sbFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'I' && !sbToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                type: "SB",
                radioType: radioType,
                sbLocationValue: sbLocationValue,
                // ppCorporate: ppCorporate,
                sbDealer: sbDealer,
                sbNewDate: Common.dateYMD(sbNewDate),
                sbSrnoTo: sbSrnoTo,
                sbSrnoFrom: sbSrnoFrom,
                sbFromDate: Common.dateYMD(sbFromDate),
                sbToDate: Common.dateYMD(sbToDate)
            }
            Common.callApi(Common.apiTranSB, [sid, "sblist", JSON.stringify(obj)], result => {
                $(".loader").hide();
                setSBList(JSON.parse(result));
            });
        }
    }

    const addNewForm = () => {
        var d = Common.dateYMD(sbNewDate);
        var ddmy = Common.dateDMY(sbNewDate);
        var ymd = Common.dateYMD(sbNewDate);
        var today = Common.dateYMD(new Date());
        if (sbLocation === null) {
            setMsgBox(true);
            setMsgText("Please select location");
        } else if (d > finEndDate || d < finStartDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (d > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        } else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        } else {
            if (d == today) {
                addNewFormResetFields(ddmy, ymd);
            } else {
                const obj = {
                    billdate: d,
                    location: sbLocationValue,
                    type: "SB"
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (+resp.msg === 1) {
                        addNewFormResetFields(ddmy, ymd);
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }

    const addNewFormResetFields = (ddmy, ymd) => {
        setHdrDate(ddmy);

        setScrMode("A");
        setKey("INFO");
        setHdrSrno(0);
        setNDealer(null);
        setNExecutive(null);
        if (sbStateValue * 1 > 0 && sbStateValue != null) setNState({ value: sbStateValue, label: sbStateName });
        else setNState({ value: 0, label: "Select" });

        setPProduct("CN");
        setPIsd(null);
        setPDenomination("");
        setPQuantity("");
        setPRate("");
        setCommType("F");
        setCommValue("");
        setCommission("");
        setIsCommission("0");
        setPForexTotal(0);
        setPTotalAmount(0);
        setPCgst(0);
        setPIgst(0);
        setPUgst(0);
        setPSgst(0);
        setPRoundOff(0);
        setPOtherCharges(0);
        setPTaxableVal(0);

        setProductList([]);
        setPaymentData([]);
        setProductLineNo(0);
        setPaymentLineNo(0);
        setNManualno(null);
        setAcRemark("");
        setPAgent(null);


        setDealerName("");
        setDealerPan("");
        setDealerAddress("");
        setDealerGstin("");
        setTrandate(ymd);
    }

    const handleNewDealerChange = (value) => {
        setNDealer(value);
        Common.callApi(Common.apiTranPP, [sid, "getDealerInfo", JSON.stringify(value)], result => {
            let resp = JSON.parse(result);
            setDealerName(resp.mvli_ledger_legal_name);
            setDealerPan(resp.mvli_pancard);
            setDealerAddress(resp.mvli_address);
            setDealerGstin(resp.mvli_gstin);

        });
    }

    const handleTabChange = (k) => {
        setKey(k);
        if (k === "PAYMENT") {
            const amt = paymentData.reduce((total, payment) => total + payment.tp_amount * 1, 0);
            setPdAmount(1 * pTotalAmount - amt);
            // const obj = {
            //     nCorporate: nCorporate
            // }
            // Common.callApi(Common.apiTranPP, [sid, "getcorporate", JSON.stringify(obj)], result => {
            //     setPdAccountOptions(JSON.parse(result));
            // });
        }
    }

    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN(Common.getMessage("WRN0000"));
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    const editData = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

        const obj = {
            srno: hdrSrno,
            type: 'SB',
            pageright: 'TRAN_SB',
            location: sbLocationValue
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setScrMode('E');
                if (productList.length > 0) {
                    setDisableOtherCharge(false);
                }
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'SB', trannumber: hdrSrno, location: sbLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })
        if (productList.length > 0) {
            setDisableOtherCharge(false);
        }
    }

    const handleCommissionCalc = (v) => {
        Common.validateDecValue(v, setCommission);
        setCommValue(calcCommission(v * 1, commType, pQuantity, pDenomination, pRate));
    }

    const commissionTypeChange = (v) => {
        setCommType(v);
        setCommission("");
        setCommValue("");
    }

    const handleAgentChange = (value) => {
        setPAgent(value);
        Common.callApi(Common.apiTranPP, [sid, "getAgentInfo", JSON.stringify(value)], result => {
            let resp = JSON.parse(result);
            setAgentName(resp.mvli_ledger_legal_name);
            setAgentPan(resp.mvli_pancard);
            setAgentAddress(resp.mvli_address);
        });
        setCommType("F");
        /*
            Common.callApi(Common.apiLedger, [sid, "getisdcommission", value.id, pIsdId, pProduct], result => {
                console.log(result);
                let resp = JSON.parse(result);
                setCommType(resp.type);
                setCommission(resp.value);
                var commvalue;
                if (resp.type === "P" || resp.type === "R") {
                    commvalue = calcCommission(resp.value, resp.type, pQuantity, pDenomination, pRate);
                } else {
                    commvalue = resp.value;
                }
                setCommValue(commvalue);
            });
        */
    }

    const handleChangeIsd = (value) => {
        setPIsd(value);
        let a = value.id.split("^");
        setPIsdId(a[1]);
        setPAgent(null);
        setCommType("F");
        setCommValue("");
        setCommission("");
        const obj = {
            isd: a[1],
            location: sbLocationValue,
            product: pProduct
        }
        Common.callApi(Common.apiMasterIBR, [sid, "getrate", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setPRate(resp.salerate * 1);
            setMaxPRate(resp.maxsalerate * 1);
            setMinPRate(resp.minsalerate * 1);
            setUsdRate(resp.usdratesale * 1);
        });
    }

    const handleRateChange = (v) => {
        Common.validateDecValue(v, setPRate);
        if (pIsdId === "USD") {
            Common.validateDecValue(v, setUsdRate);
        }
        setCommValue(calcCommission(commission, commType, pQuantity, pDenomination, v));
    }

    const handleDenoChange = (v) => {
        Common.validateDecValue(v, setPDenomination);
        setCommValue(calcCommission(commission, commType, pQuantity, v, pRate));
    }

    const handleQuantityChange = (v) => {
        Common.validateDecValue(v, setPQuantity);
        setCommValue(calcCommission(commission, commType, v, pDenomination, pRate));
    }

    const calcCommission = (value, type, quantity, deno, rate) => {
        var comm = 0;
        if (type === "P") {
            comm = (value * quantity * deno) / 100;
        } else if (type === "R") {
            comm = (quantity * deno * rate) * (value / 100);
        } else {
            comm = value;
        }
        if (comm > 0) return comm.toFixed(2);
        return comm;
    }

    const handlePaymentType = (v) => {
        $(".loader").show();
        setDisablePaymentAccount(false);
        setPdPaymentType(v);
        setPdAccount(null);
        setPdChequeNum("");
        var ldgType = "";
        if (v === "") {
            $(".loader").hide();
            return;
        }
        if (v === "CH")
            ldgType = "CASH";
        else if (v === "BN") {
            ldgType = "BANK";
            setLdgSrchType("BANK");
            $(".loader").hide();
            return;
        } else if (v === "CQ") {
            ldgType = "CHEQUE";
        }
        else if (v === "RC") {
            //ldgType = "WALKIN";
            if (nDealer !== null) {
                setPdAccount(nDealer);
                setDisablePaymentAccount(true);
            }
            $(".loader").hide();
            return;
        } else
            ldgType = "BANK";

        setLdgSrchType(ldgType);
        Common.callApi(Common.apiLedger, [sid, "getledgerinfo", ldgType], result => {
            let resp = JSON.parse(result);
            setPdAccount({ id: resp.id, label: resp.label });
            $(".loader").hide();
        });
    }

    const handleAccountValue = (value) => {
        setPdAccount(value);
        var id = value.id.split("^");
    }

    const calcInvoice = (productlist, obj) => {
        Common.callApi(Common.apiCalcTaxable, [sid, "calcinvoice", JSON.stringify(productlist), JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setPForexTotal(resp.fxamt);
            setPSgst(resp.sgst);
            setPTotalAmount(resp.totalamt);
            setPTaxableVal(resp.taxablevalue);
            setPRoundOff(resp.roundoff);
            setPCgst(resp.cgst);
            setPIgst(resp.igst);
            setPUgst(resp.ugst);
            var amt = 0;
            for (var i = 0; i < paymentData.length; i++) {
                amt += paymentData[i].tp_amount * 1;
            }
            setPdAmount(1 * resp.totalamt - amt);
        });
    }

    const addProduct = async () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (pIsd == null || pDenomination === "" || pQuantity === "" || pRate === "" || pRate * 1 === 0
            ||
            (+isCommission === 1 && (commType === "" || pAgent === null || commValue === ""))
        ) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd == null ? "Please select Isd." : '');
            msg[i++] = (pDenomination === '' ? "Please fill Denomination." : '');
            msg[i++] = (pQuantity == '' ? "Please fill Quantity." : '');
            msg[i++] = (pRate == '' || pRate * 1 === 0 ? "Please fill Rate." : '');
            if (+isCommission === 1 && (commType === "" || pAgent === null || commValue === "")) {
                msg[i++] = (pAgent == null ? "Agent." : '');
                msg[i++] = (commType == '' ? "Commission type." : '');
                msg[i++] = (commValue == '' ? "Commission value." : '');
            }
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (maxPRate != 0 && minPRate != 0 && (pRate > maxPRate || pRate < minPRate)) {
            $(".loader").hide();
            msg[i++] = (pRate > maxPRate ? "Maximum rate is " + maxPRate : '');
            msg[i++] = (pRate < minPRate ? "Maximum rate is " + minPRate : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            $(".loader").hide();
            var isd = pIsd.id.split("^");
            var agentgrp = 0;
            var agentaccnt = 0;
            var agentname = "";
            var issgrp = 0;
            var issaccnt = 0;
            if (pAgent !== null) {
                var agent = pAgent.id.split("^");
                agentgrp = agent[1];
                agentaccnt = agent[2];
                agentname = agent[5];
            }
            var usdAmt = 0;
            if (usdRate != "" && usdRate != 0) {
                usdAmt = (pRate * pQuantity * pDenomination) / usdRate;
            }
            const obj = {
                tranType: "SB",
                type: "SALE",
                uniquekey: Common.getRandomString(15),
                prd_line_no: 1 * productLineNo + 1,
                prd_location: sbLocationValue,
                prd_type: 'SB',
                prd_srno: hdrSrno,
                prd_isd: isd[1],
                prd_date: hdrSrno < 1 ? Common.dateYMD(sbNewDate) : hdrDateYmd,
                prd_product: pProduct,
                prd_deno: pDenomination,
                prd_qty: pQuantity,
                prd_rate: pRate,
                prd_amount: Math.round(pRate * pQuantity * pDenomination),
                // prd_from: prFrom,
                // prd_prefix: prPrefix,
                // prd_to: prTo,
                prd_group: issgrp,
                prd_account: issaccnt,
                prd_agent_group: agentgrp,
                prd_agent_ledger: agentaccnt,
                // prd_card_no: pVtmCardNo,
                isd_name: isd[2],
                randomString: randomString,
                prd_commission_type: commType,
                prd_commission_value: commValue == "" ? 0 : commValue,
                prd_commission: commission == "" ? 0 : commission,
                //nCorporate: nCorporate,
                nState: nState.value,
                pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
                ppStateType: sbStateType,
                ppStateValue: sbStateValue,
                scrMode: scrMode,
                prd_usd_rate: usdRate == "" ? 0 : Number(usdRate).toFixed(2),
                prd_usd_amount: Number(usdAmt).toFixed(2),
                prd_agent_name: agentname,
                isCommission: isCommission,
                delny: "Y"
            }
            /*
            var productlist;
            const isdAlreadyExist = isIsdAlreadyExist(obj);
            if (isdAlreadyExist.isIsdExist) {
                productlist = Common.arrayChangeItem(productList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_qty', isdAlreadyExist.prdRow.prd_qty);
                productlist = Common.arrayChangeItem(productList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_amount', isdAlreadyExist.prdRow.prd_amount);
                productlist = Common.arrayChangeItem(productList, 'prd_line_no', isdAlreadyExist.prdRow.prd_line_no, 'prd_usd_amount', isdAlreadyExist.prdRow.prd_usd_amount);
            } else {
                productlist = Common.arrayAddItem(productList, obj);
            }
            */
            if (pProduct === "CN") {
                let stock = await Common.checkAvailableStock(obj, productList);
                if (!stock) {
                    setMsgBox(true);
                    setMsgText("Not able to add " + obj.prd_isd + ", stock getting negative.");
                    return;
                }
            }
            var productlist = Common.arrayAddItem(productList, obj);
            if (productlist.length > 0) {
                setDisableOtherCharge(false);
            }
            const obj2 = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                // TLine: productLineNo + 1,
                TLoc: sbLocationValue,
                TType: 'SB',
                // TNum?
                Product: pProduct,
                ISD: isd[2],
                Deno: pDenomination,
                Quantity: pQuantity,
                Rate: pRate,
                Amount: pRate * pQuantity * pDenomination,
                // ...(pProduct === "ETC" ? {
                // ProductFrom: prFrom,
                // ProductTo: prTo,
                // ProductPrefix: prPrefix,
                ProductGroup: issgrp,
                ProductAccout: issaccnt,
                // } : {}),
                CommsnType: commType,
                AgentGroupCode: agentgrp,
                AgentLedgerCode: agentaccnt,
                CommsnRate: commValue == "" ? 0 : commValue,
                CommsnAmount: commission == "" ? 0 : commission,

            }
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            setProductList(productlist);
            setCounter(counter + 1);
            setProductLineNo(productLineNo + 1);
            setPIsd(null);
            setPDenomination("");
            setPQuantity("");
            setPRate("");
            // setPIssuer(null);
            // setPrPrefix("");
            // setPrFrom("");
            // setPrTo("");
            // setPVtmCardNo("");
            setCommValue("");
            setCommission("");

            setPAgent(null);
            setCommType("F");
            calcInvoice(productlist, obj);
            setAgentName("");
            setAgentPan("");
            setAgentAddress("");
        }
    }

    const isIsdAlreadyExist = (obj) => {
        var isIsdExist = false;
        var prdRow = {};
        for (var i = 0; i < productList.length; i++) {
            if (productList[i].prd_isd === obj.prd_isd && productList[i].prd_deno === obj.prd_deno && productList[i].prd_product === obj.prd_product) {
                prdRow.prd_line_no = productList[i].prd_line_no;
                prdRow.prd_qty = 1 * productList[i].prd_qty + obj.prd_qty * 1;
                prdRow.prd_amount = (prdRow.prd_qty * obj.prd_rate * obj.prd_deno).toFixed(2);
                prdRow.prd_usd_amount = (prdRow.prd_amount / usdRate).toFixed(2);
                isIsdExist = true;
                break;
            }
        }
        return { isIsdExist: isIsdExist, prdRow: prdRow };
    }

    const addPayment = () => {
        var msg = [], i = 0;
        if (pTotalAmount < 1) {
            msg[i++] = (pTotalAmount < 1 ? "Total amount must be greater than 0." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pdPaymentType === "" || pdAccount === null || pdAmount < 1
            || (pdPaymentType === 'CQ' && (pdChequeNum === "" || chequeBankName === "" || chequeDate === null))
            || (pdPaymentType === "BN" && pdChequeNum === "") || (pdPaymentType === "RC" && pdRemark === "")
        ) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pdAccount === null ? "Account." : '');
            msg[i++] = (pdPaymentType === "" ? "Payment Type." : '');
            msg[i++] = (pdAmount < 1 ? "Entered amount can't be 0." : '');
            msg[i++] = ((pdPaymentType === "RC" && pdRemark === "") ? "Remark " : '');
            if (pdPaymentType === 'CQ' && (pdChequeNum === "" || chequeBankName === "" || chequeDate === null)) {
                msg[i++] = (pdChequeNum === "" ? "Cheque Number." : '');
                msg[i++] = (chequeBankName === "" ? "Bank Name." : '');
                msg[i++] = (chequeDate === null ? "Cheque Date" : '');
            }
            if (pdPaymentType === "BN" && pdChequeNum === "") msg[i++] = (pdChequeNum === "" ? "Reference Number." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {

            // Check for duplicate reference number if payment type is BN and CQ
            if ((pdPaymentType === "BN" || pdPaymentType === "CQ") && pdChequeNum !== "") {
                const isDuplicateRef = paymentData.some(item =>
                    item.tp_payment_type === pdPaymentType &&
                    item.tp_cheque === pdChequeNum
                );

                if (isDuplicateRef) {
                    msg[i++] = `Reference number '${pdChequeNum}' is already used for '${pdPaymentType}.`;
                    setMsgText(Common.buildMessageFromArray(msg));
                    setMsgBox(true);
                    return;
                }
            }

            var grp = 0;
            var accnt = 0;
            var accntname = '';
            if (pdAccount !== null) {
                var a = pdAccount.id.split("^");
                grp = a[1];
                accnt = a[2];
                if (pdPaymentType === "CQ") {
                    accntname = a[4];
                } else {
                    accntname = a[5];
                }
            }
            const obj = {
                uniquekey: Common.getRandomString(10),
                tp_line_no: paymentLineNo + 1,
                tp_location: sbLocationValue,
                tp_srno: hdrSrno,
                tp_payment_type: pdPaymentType,
                tp_account: accnt,
                tp_group: grp,
                mvli_ledger_name: accntname,
                tp_amount: pdAmount,
                tp_cheque: pdChequeNum,
                tp_cheque_bank: chequeBankName,
                tp_cheque_date: pdPaymentType === "CQ" ? Common.dateYMD(chequeDate) : "NULL",
                tp_type: "SP",
                tp_remark: pdRemark,
                delny: 'Y'
            }
            const existingItem = Common.isSamePaymentMethod(obj, paymentData);
            // if (existingItem) {
            //     existingItem.tp_amount = (existingItem.tp_amount * 1 || 0) + (obj.tp_amount * 1 || 0);
            //     existingItem.tp_cheque = pdChequeNum;
            //     existingItem.tp_remark = pdRemark;
            // } else {
            const paymentdata = Common.arrayAddItem(paymentData, obj);
            setPaymentData(paymentdata);
            const obj2 = {
                TabType: "Payment",
                AType: "A",
                ALineNo: tranAuditTrail.length + 1,
                // TLine: paymentLineNo + 1,
                TLoc: sbLocationValue,
                TType: 'SB',
                PaymentType: pdPaymentType,
                PaymentLedgerCode: accnt,
                PaymentGroupCode: grp,
                PaymentAccountName: accntname,
                PaymentAmount: pdAmount,
                // ...(pdPaymentType == "BN" ? {
                ReferenceNo: pdChequeNum,
                Remark: pdRemark,
                // } : {}),
            }
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            // }
            setPdPaymentType("");
            setPaymentLineNo((1 * paymentLineNo) + 1);
            setPdAmount("");
            setPdAccount(null);
            setPdChequeNum("");
            setChequeBankName("");
            setChequeDate(null);
            setCounter(counter + 1);
            setPdRemark("");
            // setPRoundOff(0); 
            //  here round 
            const amt = paymentData.reduce((total, payment) => total + payment.tp_amount * 1, 0);
            setPdAmount(1 * pTotalAmount - amt);
        }
    }

    const deleteProduct = (value) => {
        const itemToDelete = productList.find(item => item.uniquekey === value);

        if (itemToDelete) {
            const formattedItem = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: sbLocationValue,
                TType: 'SB',
                Product: itemToDelete.prd_product,
                ISD: itemToDelete.isd_name,
                Deno: itemToDelete.prd_deno,
                Quantity: itemToDelete.prd_qty,
                Rate: itemToDelete.prd_rate,
                Amount: itemToDelete.prd_amount,
                ProductFrom: itemToDelete.prd_from,
                ProductTo: itemToDelete.prd_to,
                ProductPrefix: itemToDelete.prd_prefix,
                ProductGroup: itemToDelete.prd_group,
                ProductAccout: itemToDelete.prd_account,
                AgentGroupCode: itemToDelete.prd_agent_group,
                AgentLedgerCode: itemToDelete.prd_agent_ledger,
                CommsnType: itemToDelete.prd_commission_type,
                CommsnRate: itemToDelete.prd_commission_value,
                CommsnAmnt: itemToDelete.prd_commission,
            }
            console.log(formattedItem);
            if (+userRight.edit === 1 && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }
        }
        const obj = {
            tranType: "SB",
            type: "SALE",
            nState: nState.value,
            pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
            ppStateType: sbStateType,
            ppStateValue: sbStateValue
        }
        const productlist = Common.arrayRemoveItem(productList, "uniquekey", value);
        setProductList(productlist);
        calcInvoice(productlist, obj);
        setCounter(counter - 1);
    }

    const deletePayment = (value, delny) => {
        if (delny === "N") {
            setMsgBox(true);
            setMsgText("This cheque has already used.");
        } else {
            const itemToDelete = paymentData.find(item => item.uniquekey === value);

            if (itemToDelete) {
                const formattedItem = {
                    TabType: "Payment",
                    ALineNo: tranAuditTrail.length + 1,
                    AType: "D",
                    TLine: paymentLineNo + 1,
                    TLoc: sbLocationValue,
                    TType: 'SB',
                    PaymentType: itemToDelete.tp_payment_type,
                    PaymentGroupCode: itemToDelete.tp_group,
                    PaymentLedgerCode: itemToDelete.tp_account,
                    PaymentAccountName: itemToDelete.mvli_ledger_name,
                    PaymentAmount: itemToDelete.tp_amount,
                    ReferenceNo: itemToDelete.tp_cheque,
                };
                if (+userRight.edit === 1 && scrMode === 'E') {
                    setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
                }

            }
            const paymentdata = Common.arrayRemoveItem(paymentData, "uniquekey", value);
            setPaymentData(paymentdata);

            const amt = paymentData.reduce((total, payment) => total + payment.tp_amount * 1, 0);
            setPdAmount(1 * pTotalAmount - amt);
        }
        setCounter(counter - 1);
    }

    const saveData = (issavedealer) => {
        $(".loader").show();
        var msg = [], i = 0;
        var totalinr = 0;
        for (var i = 0; i < paymentData.length; i++) {
            if (paymentData[i].tp_payment_type === "PB")
                totalinr -= paymentData[i].tp_amount * 1;
            else totalinr += paymentData[i].tp_amount * 1;
        }
        if (nDealer === null || nExecutive === null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (nExecutive === null ? "Executive" : '');
            msg[i++] = (nDealer === null ? "Dealer" : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (pTotalAmount != totalinr) {
            $(".loader").hide();
            setMsgText("Total amount of payment must be equal to calculated INR.");
            setMsgBox(true);
        } else if (acRemark === '' && issavedealer === true) {
            setShowModal(false);
            setMsgText('Please fill Remark!');
            setMsgBox(true);
            $(".loader").hide();
        } else if (scrMode === 'A' && productList.length < 1) {
            setMsgText("Productlist can't be empty.");
            setMsgBox(true);
            $(".loader").hide();
        } else {
            setShowModal(false);
            const obj = {
                type: 'SB',
                srno: hdrSrno,
                sbLocationValue: sbLocationValue,
                //spSaleType: spSaleType,
                sbNewDate: hdrSrno < 1 ? Common.dateYMD(sbNewDate) : hdrDateYmd,
                //nCorporate: nCorporate,
                nDealer: nDealer,
                nTranType: nTranType,
                // nCountry: nCountry,
                nState: nState.value,
                //nResident: nResident,
                //nTraveller: nTraveller,
                //nPurpose: nPurpose,
                nExecutive: nExecutive,
                pForexTotal: pForexTotal,
                //nFlightNo: nFlightNo,
                //nTicketNo: nTicketNo,
                //nVisaType: nVisaType,
                //nDepDate: Common.dateYMD(nDepDate),
                //nTicketClass: nTicketClass,
                //nDuration: nDuration,
                //nPanForm60: nPanForm60,
                nMode: nMode,
                pSgst: pSgst,
                pIgst: pIgst,
                pUgst: pUgst,
                pCgst: pCgst,
                pOtherCharges: pOtherCharges === "" ? 0 : pOtherCharges,
                pRoundOff: pRoundOff,
                pTaxableVal: pTaxableVal,
                pTotalAmount: pTotalAmount,
                //nTravellerCode: nTravellerCode,
                //randomString: randomString,
                sbProductList: productList,
                paymentData: paymentData,
                radioType: radioType,
                sbSrnoTo: sbSrnoTo,
                sbSrnoFrom: sbSrnoFrom,
                sbFromDate: Common.dateYMD(sbFromDate),
                sbToDate: Common.dateYMD(sbToDate),
                nRemark1: nRemark1,
                nRemark2: nRemark2,
                nManualno: nManualno,
                issavedealer: issavedealer,
                riskValue: riskValue,
                riskRemark: acRemark,
            }
            const infoObject = Common.compareArrays(compareData, [obj]);

            if (+userRight.edit === 1 && scrMode === "E") {
                setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, 'SB', sbLocationValue));
            }

            var msg = "";
            Common.callApi(Common.apiTranSB, [sid, "savedata", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], result => {
                let resp = JSON.parse(result);
                $(".loader").hide();
                if (resp.blacklistedYN?.isBlackListed && +resp.blacklistedYN.isBlackListed === 1) {
                    setMsgText(resp.blacklistedYN.name + " can't saved.Dealer is Red Flags." + resp.blacklistedYN.tsa_master + " " + resp.blacklistedYN.tsa_data_id + " " + "</br> Contact to compliance department.");
                    setMsgBox(true);
                    return;
                }
                if (resp.msg === "MSG0000") {
                    setSBList(resp.data);
                    setScrMode("Q");
                    setKey("DETAILS");
                    let paramDate = Common.dateYMD(sbNewDate);
                    if (hdrSrno > 0) {
                        paramDate = hdrDateYmd;
                    }
                    fillViewForm(resp.srno, paramDate);
                    if (typeof resp.irn.Status !== "undefined") {
                        if (resp.irn.Status == "0") {
                            msg = ", IRN generation failed.";
                            alert(JSON.stringify(resp.irn.ErrorDetails));
                        } else {
                            setIrnObj({
                                irn: resp.irn.Data.Irn,
                                ackdate: resp.irn.Data.AckDt,
                                acknum: resp.irn.Data.AckNo,
                                signedqr: resp.irn.Data.SignedQRCode
                            });
                        }
                    }
                    if (resp.printhtml != "" && +Common.Billprint === 1) {
                        var newWindow = window.open();
                        newWindow.document.write(resp.printhtml);
                    }
                    setMsgBox(true);
                    setMsgText(Common.getMessage(resp.msg) + msg);
                    setTranAuditTrail([]);
                    expireUnlock();
                    setAcRemark("");
                } else if (resp.msg['riskvalue'] === '2') {
                    setShowModal(true);
                    setRiskModalBoxText(resp.msg['ledgername'] + " is medium risk. Please take the extra documentation.");
                    setRiskValue(resp.msg['riskvalue']);
                } else if (resp.msg['riskvalue'] === '3') {
                    setMsgBox(true);
                    setMsgText(resp.msg['ledgername'] + " is high risk.\nTransaction can not be saved.\n Please contact to compliance department.");
                } else if (resp.msg === "ERR0000") {
                    setMsgBox(true);
                    setMsgText(Common.getMessage("ERR0000"));
                } else {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                }
            });
        }
    }

    const expireUnlock = () => {
        if (scrMode == 'E' && unlockRequestType !== "SELF") {
            const currentDate = new Date();
            const obj = {
                srno: hdrSrno,
                type: 'SB',
                status: 'E',
                currentDate: Common.dateYMD(currentDate),
                pageright: 'TRAN_SB'
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            });
        }
    }
    const fillViewCompareObject = (resp) => {
        const obj2 = {
            nExecutive: resp.executive == "^0^" ? null : { id: resp.executive, label: resp.executive_name },
            nMode: resp.mode,
            nDealer: resp.dealerid === "^0^0^" ? null : { id: resp.dealerid, label: resp.dealerlabel },
            nRemark1: resp.remark1,
            nRemark2: resp.remark2,
        }
        setCompareData([obj2]);
    }

    const fillViewForm = (hdrsrno, date) => {
        setHdrSrno(hdrsrno);
        setKey('INFO');
        //setRandomString("0");
        $(".loader").show();
        setViewDate(date);
        const obj = {
            srno: hdrsrno,
            sbLocationValue: sbLocationValue,
            type: "SB"
        }
        Common.callApi(Common.apiTranSB, [sid, "viewdata", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "MSG0000") {
                fillViewCompareObject(resp);
                $(".loader").hide();
                setScrMode("Q");
                if (resp.executive == "^0^") setNExecutive(null);
                else setNExecutive({ id: resp.executive, label: resp.executive_name });
                setNMode(resp.mode);
                //setNPurpose({ id: resp.purpose, label: resp.purpose_name });
                if (resp.dealerid === "^0^0^") {
                    setNDealer(null);
                }
                else {
                    setNDealer({ id: resp.dealerid, label: resp.dealerlabel })
                    setDealerName(resp.dealerid.split("^")[12]);
                    setDealerPan(resp.dealerid.split("^")[13]);
                    setDealerAddress(resp.dealerid.split("^")[16]);
                    setDealerGstin(resp.dealerid.split("^")[10]);
                };

                setPForexTotal(resp.forextotal);
                setPCgst(resp.cgst);
                setPSgst(resp.sgst);
                setPIgst(resp.igst);
                setPUgst(resp.ugst);
                setPRoundOff(resp.round_off);
                setPTotalAmount(resp.total_inr);
                setPOtherCharges(resp.other_charge);
                setPTaxableVal(resp.taxablevalue);
                setNRemark1(resp.remark1);
                setNRemark2(resp.remark2);

                setProductList(resp.productlist);
                setPaymentData(resp.paydetails);
                setPaymentLineNo(resp.paymaxlineno);
                setProductLineNo(resp.maxlineno);

                setHdrDate(resp.date);
                setHdrLocation(resp.locname);

                setHdrDateYmd(resp.dateymd);
                setIsIrnApplicable(resp.is_irn_applicable);

                setIsIrnGenerated(resp.isIrnGenerated);
                setIsIrnCancelled(resp.isIrnCancelled);
                setIrnCancelDate(resp.irncanceldt);
                setIrnCancelRemarkHdr(resp.irncancelrmk);
                setCancelButtonView(+resp.hdr_cancel_billYN === 1 ? false : true);
                setTrandate(resp.ymdDate);


                if (resp.manualid == null) setNManualno(null);
                else setNManualno({ id: resp.manualid, label: resp.manuallabel });

                if (+resp.isIrnGenerated === 1) {
                    setIrnObj({
                        irn: resp.irn,
                        ackdate: resp.ackdate,
                        acknum: resp.ackno,
                        signedqr: resp.signedqr
                    });
                }
                if (!(resp.irncancelreason == null || resp.irncancelreason == "")) {
                    setIrnCancelReasonHdr(Common.getIrnCancelReason.find(item => item.id == resp.irncancelreason).desc);
                }
            }
        });
    }

    const switchToPaymentTab = (e) => {
        if (e.key === 'Enter') setKey("PAYMENT");
        else if (e.key === "Tab") {
            e.preventDefault();
            isdRef.current.focus();
        }
    }


    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: sbLocationValue, trannumber: hdrSrno, type: 'SB' });
    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "SB", trannumber: hdrSrno, trancategory: "T", location: sbLocationValue });
    }

    const handleShowCommissionDetail = () => {
        setShowCommissionDetail(true);
    }

    const cancelBillFinalModal = () => {
        setMsgBoxCancelBill(true);
        setMsgTextCancelBill("Alert!");
        setIrnCancelDeclaration(false);
        setIrnCancelReason("");
        setIrnCancelLabel("I confirm the deletion of this bill.");
        setIrnCancelReasonSelect("");
    }

    const generateIrn = () => {
        const obj1 = {
            coporate: nDealer,
            location: sbLocationValue,
            billdate: hdrDateYmd,
            hdrsrno: hdrSrno,
            type: 'SB',
            pForexTotal: pForexTotal,
            pSgst: pSgst,
            pIgst: pIgst,
            pUgst: pUgst,
            pCgst: pCgst,
            pOtherCharges: pOtherCharges,
            pRoundOff: pRoundOff,
            pTaxableVal: pTaxableVal === "" ? 0 : pTaxableVal,
            pTotalAmount: pTotalAmount,
            productList: productList,
            ppStateType: sbStateType,
            ppStateValue: sbStateValue,
            nState: nState.value,
        }
        $(".loader").show();
        Common.callApi(Common.apiEInvoice, [sid, "generateirn", JSON.stringify(obj1)], result => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            if (resp.msg != "") {
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                if (resp.irn.Status == "0") {
                    alert(JSON.stringify(resp.irn.ErrorDetails));
                } else {
                    setScrMode("");
                    setMsgBox(true);
                    setMsgText("IRN Generated successfully.");
                }
            }
        });
    }

    const cancelBill = () => {
        const obj1 = {
            hdrSrno: hdrSrno,
            location: sbLocationValue,
            type: 'SB',
            irnObj: irnObj,
            irnCancelReason: irnCancelReason,
            irnCancelReasonSelect: irnCancelReasonSelect
        }
        if (irnCancelReason === "") {
            setMsgBoxCancelBill(false);
            setMsgBox(true);
            setMsgText("Please fill reason.");
            return;
        }
        if (!irnCancelDeclaration) {
            setMsgBoxCancelBill(false);
            setMsgBox(true);
            setMsgText("Please check the declaration.");
            return;
        }
        $(".loader").show();
        Common.callApi(Common.apiEInvoice, [sid, 'cancelirn', JSON.stringify(obj1)], result => {
            $(".loader").hide();
            setMsgBoxCancelBill(false);
            let resp = JSON.parse(result);
            if (resp.Status == "2") {
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                if (resp.Status == "1") {
                    setScrMode("");
                    setMsgBox(true);
                    setMsgText("IRN cancelled successfully, Cancel Date " + resp.Data.CancelDate);
                } else {
                    alert(JSON.stringify(resp.ErrorDetails));
                }
            }
        });
    }

    const print = (printflag) => {
        $(".loader").show();
        if (isIrnGenerated === "0" && isIrnApplicable === "Y") {
            setMsgText("Irn not generated.");
            $(".loader").hide();
            setMsgBox(true);
        } else {
            const obj = {
                srno: hdrSrno,
                location: sbLocationValue,
                type: 'SB',
                printFlag: printflag,
            }
            Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
                $(".loader").hide();
                var newWindow = window.open();
                newWindow.document.write(result);
            });
        }
    }
    const handleMinMaxRate = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (pIsd === null) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd === null ? " Select ISD." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            setShowMinMaxRateModal(true);
            setPIsd(pIsd);
            let a = pIsd.id.split("^");
            setPIsdId(a[1]);//
            setPAgent(null);
            setCommType("F");
            setCommValue("");
            const obj = {
                isd: a[1],
                location: sbLocationValue,
                product: pProduct
            }
            Common.callApi(Common.apiMasterIBR, [sid, "getrate", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                if (resp === "") {
                    alert("Select Individual First ");
                    // setMinMaxRate("");
                    $(".loader").hide();
                } else {
                    if (Array.isArray(resp)) {
                        setMinMaxRate(resp);
                    } else if (resp && typeof resp === 'object') {
                        setMinMaxRate([resp]);
                    }
                    $(".loader").hide();
                }
            });
        }
    }

    const handleManualNo = (value) => {
        setNManualno(value);
    }

    const changeDateModal = () => {
        var isOk = true;
        var msg = [], i = 0;
        if (productList.length > 0) {
            isOk = false;
            msg[i++] = "Please empty Product List.";
        }
        if (paymentData.length > 0) {
            isOk = false;
            msg[i++] = "Please empty Payment List.";
        }

        if (isOk) {
            setOpenDateChangeModal(true);
            setChangeDateObj(
                {
                    type: "SB",
                    srno: hdrSrno,
                    location: sbLocationValue,
                    right: "TRAN_SB",
                    billdate: hdrDate,
                    billdateymd: hdrDateYmd,
                    productList: productList
                }
            );
        } else {
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
    }

    const handleStock = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (pIsd === null || !pDenomination) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (pIsd === null ? "ISD." : '');
            msg[i++] = (!pDenomination ? "Denomination." : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            let a = pIsd.id.split("^");
            const obj = {
                isd: a[1],
                date: hdrSrno > 0 ? hdrDateYmd : Common.dateYMD(sbNewDate),
                deno: pDenomination,
                location: sbLocationValue,
                // srno: hdrSrno,
                // type: 'SB'
            }
            Common.callApi(Common.apiMasterIBR, [sid, "checkStock", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                $(".loader").hide();
                if (resp.status) {
                    // const msg = Common.getStockModelContent(a[1], pDenomination, resp.quantity)
                    setShowStockModal(true);
                    setStockObj({ isd: a[1], quantity: resp.quantity, deno: pDenomination });
                } else {
                    setMsgText(Common.buildMessageFromArray(resp.msg));
                    setMsgBox(true);
                }
            });
        }
    }

    const handleCancelBill = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

        const obj = {
            srno: hdrSrno,
            type: 'SB',
            pageright: 'TRAN_SB',
            location: sbLocationValue
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setMsgTextYNBillDelete("Are you sure.");
                setMsgBoxYNBillDelete(true);
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'SB', trannumber: hdrSrno, location: sbLocationValue, tranDate: Common.dateYMD(currDate) });
            }
        })

    }
    const handleDeleteBill = (remark) => {
        setMsgBoxYNBillDelete(false);
        const obj = {
            type: 'SB',
            location: sbLocationValue,
            srno: hdrSrno,
            productList: productList,
            paymentList: paymentData,
            remark: remark,
        }
        Common.callApi(Common.apideletebill, [sid, 'deletebill', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            if (resp.err == "") {
                setScrMode("");
                listSBdata();
                setMsgText(resp.msg);
                setMsgBox(true);
            } else {
                setMsgText(resp.msg);
                setMsgBox(true);
            }
        })
    }

    const roundOffHandler = (val) => {
        console.log(val)
        if (val === '') {
            setPRoundOff(0);
            setPTotalAmount((pForexTotal * 1) + pUgst + pSgst + pCgst + pIgst + pOtherCharges * 1);
            setPdAmount((pForexTotal * 1) + pUgst + pSgst + pCgst + pIgst + pOtherCharges * 1)
        } else
            if (val != '' && typeof (val * 1) === 'number') {
                setPRoundOff(val * 1);
                setPTotalAmount((val * 1) + (pForexTotal * 1) + pUgst + pSgst + pCgst + pIgst + pOtherCharges * 1);
                setPdAmount((val * 1) + (pForexTotal * 1) + pUgst + pSgst + pCgst + pIgst + pOtherCharges * 1)
                // handleTabChange('PAYMENT');
            }
    }

    const handleSetIsCommission = (value) => {
        setIsCommission(value);
        setPAgent(null);
        setCommType("F");
        setCommValue("");
        setCommission("");
    }

    const handleNextBill = () => {
        const obj = {
            location: sbLocationValue,
            type: "SB",
            srno: hdrSrno,
            hdr_tran_source: ""
        };
        Common.callApi(Common.apiCommom, [sid, "Nextbillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            console.log(resp);
            if (resp.srno) {
                fillViewForm(resp.srno, resp.date);
            } else {
                setMsgText("No next bill available.");
                setMsgBox(true);
            }
        });
    }

    const handlePrevBill = () => {
        const obj = {
            location: sbLocationValue,
            type: "SB",
            srno: hdrSrno,
            hdr_tran_source: ""
        };
        Common.callApi(Common.apiCommom, [sid, "Prebillexists", JSON.stringify(obj)], result => {
            const resp = JSON.parse(result);
            console.log(resp);
            if (resp.srno) {
                fillViewForm(resp.srno, resp.date);
            } else {
                setMsgText("No previous bill available.");
                setMsgBox(true);
            }
        });
    }


    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Sale Bulk</h2>
                    </Col>
                </Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Col className='col-md-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                            <Col>
                                                <Form.Check checked={radioType === "I"} onChange={() => setRadioType("I")} type='radio' label="Dealer" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={sbLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedWithoutHoPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleLocationChange}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === "N" ?
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Date</Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={sbNewDate}
                                                    onChange={(date) => setSBNewDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        : radioType === "S" ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={5} value={sbSrnoFrom} onChange={e => Common.validateNumValue(e.target.value, setSBSrnoFrom)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <Form.Control type='text' maxLength={5} value={sbSrnoTo} onChange={e => Common.validateNumValue(e.target.value, setSBSrnoTo)} />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            : radioType === "D" || radioType === "I" ?
                                                <>
                                                    {
                                                        radioType === "I" ?
                                                            <Col className="col-md-6 col-12">
                                                                <Form.Group>
                                                                    <Form.Label>Dealer<span className="colorThemeRed">*</span></Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={sbDealer}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={(search) => Picklist.fetchDealerTypePicklist(search, sbLocationValue, "2,3,4", trandate)}
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={handleDealerChange}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Form.Group>
                                                            </Col>
                                                            : null
                                                    }
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={sbFromDate}
                                                                onChange={(date) => setSBFromDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={sbToDate}
                                                                onChange={(date) => setSBToDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                                : null
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        +userRight.query === 1 && radioType !== "N" ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => listSBdata()}>List</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        +userRight.add === 1 && radioType === "N" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNewForm()}>Add New</Button> : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Table responsive striped>
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>Sr No</th>
                                            <th>Type</th>
                                            <th>Date</th>
                                            <th>Location</th>
                                            <th>Dealer</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            sbList.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <span onClick={() => fillViewForm(item.hdr_srno, item.new_date)} className='pointer colorThemeBlue'>
                                                            <FontAwesomeIcon icon={faEye} />
                                                        </span>
                                                    </td>
                                                    <td>{item.hdr_srno}</td>
                                                    <td>{item.hdr_type}</td>
                                                    <td>{item.hdr_date}</td>
                                                    <td>{item.entity_name}</td>
                                                    <td>{item.mvli_ledger_name}</td>
                                                    <td>{item.hdr_total_inr}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Row>
                        </>
                        :
                        <>
                            <Row style={{ display: (hdrSrno < 1 || isIrnApplicable === "N") && "none" }}>
                                <Col>
                                    {
                                        +isIrnCancelled === 1 ?
                                            <div className='d-flex align-items-baseline'>
                                                <p><span style={{ color: "red" }}><FontAwesomeIcon icon={faCircleXmark} /></span> <b>Bill Deleted</b></p>
                                                <p className='mx-2'>Delete Date : <b>{irnCancelDate}</b></p>
                                                <p className='mx-2'>Reason of Deletion: <b>{irnCancelReasonHdr}</b></p>
                                                <p className='mx-2'>Deletion Remark: <b>{irnCancelRemarkHdr}</b></p>
                                            </div>
                                            :
                                            <>
                                                {
                                                    +isIrnGenerated === 1 ?
                                                        <div className='d-flex align-items-baseline'>
                                                            <p><span style={{ color: "green" }}><FontAwesomeIcon icon={faCircleCheck} /></span> <b>IRN Generated</b></p>
                                                            {
                                                                +userRight.delete === 1 &&
                                                                <Badge className='mx-2 pointer' bg='danger' onClick={cancelBillFinalModal}>Delete Bill</Badge>
                                                            }
                                                        </div>
                                                        :
                                                        <div className='d-flex align-items-baseline'>
                                                            <p><span style={{ color: "red" }}><FontAwesomeIcon icon={faCircleXmark} /></span> <b>IRN Generation Failed</b></p>
                                                            {
                                                                (+userRight.delete === 1 && scrMode === "Q") &&
                                                                <Badge className='mx-2 pointer' bg='warning' onClick={generateIrn}>Generate</Badge>
                                                            }
                                                        </div>
                                                }
                                            </>
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        (+userRight.edit === 1 && scrMode === 'Q' && cancelButtonView) ? <>
                                            <Button style={{ display: +isIrnGenerated === 1 && "none" }} variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                editData()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (+userRight.edit === 1 && scrMode === 'E') || (+userRight.add === 1 && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData(false)}>Save</Button>
                                        </> : null
                                    }
                                    {/* {
                                        (userRight.query === "1") ? <>
                                            <Button variant='outline-success' size='sm' className='buttonStyle' onClick={() => print("D")}>With Deno</Button>&nbsp;
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => print("")}>Without Deno</Button>
                                        </> : null
                                    } */}
                                    {
                                        (+userRight.query === 1 && scrMode === "Q") ?
                                            <>
                                                {
                                                    +Common.Billprint === 1 &&
                                                    <>
                                                        <Button variant='outline-success' size='sm' className='buttonStyle divHide' onClick={() => print("D")}>With Deno</Button>&nbsp;
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => print("")}>Without Deno</Button>&nbsp;
                                                    </>
                                                }
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                                {(+userRight.query === 1 && scrMode === 'Q') ? <>
                                                    <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                        btnActivityLog()}>Activity Log</Button>&nbsp;
                                                </> : null
                                                }
                                            </> : null
                                    }
                                    {
                                        scrMode === "Q" &&
                                        <Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.delete === 1) &&
                                        <>
                                            &nbsp;
                                            {+dateChangeRight?.query === 1 &&
                                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => changeDateModal()}>Date Change</Button>}
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userCancelBillRight.query === 1 && cancelButtonView) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.query === 1) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-primary    " className='buttonStyle' size="sm" onClick={() => handlePrevBill()}>Prev Bill</Button>
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.query === 1) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleNextBill()}>Next bill</Button>
                                        </>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className="col-md-2 col-4">
                                    <span>Srno : <b>{hdrSrno} </b></span>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Location : <b>{hdrLocation} </b></span>
                                </Col>
                                <Col className="col-md-2 col-4">
                                    <span>Date : <b>{hdrDate}</b></span>
                                </Col>
                                <Col className='ppCharges'>
                                    <span><b>Forex Total (INR): {pForexTotal}</b></span>
                                    &nbsp;&nbsp;&nbsp;
                                    <span><b>Total Amount (INR): {pTotalAmount}</b></span>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                <Tab eventKey="INFO" title="Info">
                                    <Row>
                                        <Col><h4>Transaction Info</h4></Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Executive<span className="colorThemeRed">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nExecutive}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={Picklist.fetchExecutivePicklist}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleExecutiveChange}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Mode<span className="colorThemeRed">*</span></Form.Label>
                                                <Form.Select disabled={scrMode === "Q"} value={nMode} onChange={e => setNMode(e.target.value)}>
                                                    <option value="B">In Branch</option>
                                                    <option value="D">Delivery</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col><h4>Dealer Info</h4></Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-md-12 col-12">
                                            <Form.Group>
                                                <Form.Label style={{ display: "flex", alignItems: "center" }}>
                                                    <span>Dealer<span className="colorThemeRed">*</span></span>
                                                    <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={() => setNDealer(null)}><Badge bg="secondary">Reset</Badge></span>
                                                </Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nDealer}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchDealerTypePicklist(search, sbLocationValue, "2,3,4,8", trandate)}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleNewDealerChange}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Row>
                                            <Col className='col-md-3 col-3'>
                                                <Form.Label>Name : <b>{dealerName}</b></Form.Label>
                                            </Col>
                                            <Col className="col-md-2 col-2">
                                                <span>Pan : <b>{dealerPan} </b></span>
                                            </Col>
                                            <Col className="col-md-2 col-2">
                                                <span>Gstin : <b>{dealerGsitn}</b></span>
                                            </Col>
                                            <Col>
                                                <span>Address : <b>{dealerAddress}</b></span>
                                            </Col>
                                        </Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Transaction Type</Form.Label>
                                                <Form.Select disabled={scrMode === "Q"} value={nTranType} onChange={e => setNTranType(e.target.value)}>
                                                    <option value="AF">ADS and FFMC</option>
                                                    <option value="DB">DESPATCH ABROAD</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Manual Number</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={nManualno}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchManualTypePicklist(search, sbLocationValue, 'SB')} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleManualNo}
                                                    isDisabled={scrMode === "Q"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Remark 1</Form.Label>
                                                <Form.Control type="text" maxLength={100} placeholder='Remark 1' disabled={scrMode === "Q"} value={nRemark1} onChange={e => setNRemark1(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Remark 2</Form.Label>
                                                <Form.Control type="text" maxLength={100} placeholder='Remark 2' disabled={scrMode === "Q"} value={nRemark2} onChange={e => setNRemark2(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='col-md-3 col-6 mt-2'>
                                            <Button variant='outline-secondary' size='sm' onClick={() => setKey("DETAILS")}>Details-&gt;</Button>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                </Tab>
                                <Tab eventKey="DETAILS" title="Details">
                                    <Row>
                                        <Col>
                                            <h4>Product Info</h4>
                                        </Col>
                                    </Row>
                                    {
                                        scrMode === "Q" ? null
                                            :
                                            <>
                                                <Row>
                                                    <Col className='col-md-3 col-6' style={{ display: "none" }}>
                                                        <Form.Group>
                                                            <Form.Label>Product<span className="colorThemeRed">*</span></Form.Label>
                                                            <Form.Select value={pProduct} onChange={e => setPProduct(e.target.value)}>
                                                                <option value="CN">CN</option>
                                                                <option value="VTM">VTM</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    < Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>ISD<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                ref={isdRef}
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pIsd}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, pProduct)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleChangeIsd}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Denomination
                                                                <span className="colorThemeRed">*</span>
                                                            </Form.Label>
                                                            <Form.Control placeholder='Denomination' type='text' value={pDenomination} maxLength={5}
                                                                onChange={e => handleDenoChange(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Quantity<span className="colorThemeRed">*</span></Form.Label>
                                                            <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handleStock}>
                                                                <Badge className='handCursor' bg="secondary">Check Stock</Badge></span>
                                                            <Form.Control type='text' placeholder='Quantity' value={pQuantity} maxLength={9}
                                                                onChange={e => handleQuantityChange(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Rate<span className="colorThemeRed">*</span></Form.Label>
                                                            <span style={{ display: scrMode === "Q" && "none" }} className="mx-2" onClick={handleMinMaxRate}><Badge bg="secondary">See Min/Max Rate</Badge></span>
                                                            <Form.Control type='text' placeholder='Rate' value={pRate} maxLength={Common.rateMaxLength}
                                                                onChange={e => handleRateChange(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Commission</Form.Label>
                                                            <Form.Select value={isCommission} onChange={e => handleSetIsCommission(e.target.value)}>
                                                                <option value="0">No</option>
                                                                <option value="1">Yes</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        +isCommission === 1 ?
                                                            <>
                                                                <Col className='col-md-12 col-12'>
                                                                    <Form.Group>
                                                                        <Form.Label>Agent<span className="colorThemeRed">*</span></Form.Label>
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={pAgent}
                                                                            getOptionLabel={e => e.label + ' '}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'AGENT', sbLocationValue)} // location = 1 , 2
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={handleAgentChange}
                                                                        >
                                                                        </AsyncSelect>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Row>
                                                                    <Col className='col-md-3 col-3'>
                                                                        <Form.Label>Name : <b>{agentName}</b></Form.Label>
                                                                    </Col>
                                                                    <Col className="col-md-2 col-2">
                                                                        <span>Pan : <b>{agentPan} </b></span>
                                                                    </Col>
                                                                    <Col>
                                                                        <span>Address : <b>{agentAddress}</b></span>
                                                                    </Col>
                                                                </Row>
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Group>
                                                                        <Form.Label>Type<span className="colorThemeRed">*</span></Form.Label>
                                                                        <Form.Select value={commType} onChange={e => commissionTypeChange(e.target.value)}
                                                                            disabled={true}>
                                                                            <option value="F">Flat</option>
                                                                            <option value="">Select</option>
                                                                            <option value="P">Paisa</option>
                                                                            <option value="R">Percentage</option>

                                                                        </Form.Select>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Group>
                                                                        <Form.Label>Commission<span className="colorThemeRed">*</span></Form.Label>
                                                                        <Form.Control type='text' maxLength={5} value={commission} onChange={e => handleCommissionCalc(e.target.value)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Group>
                                                                        <Form.Label>Commission Value</Form.Label>
                                                                        <Form.Control disabled value={commValue} onChange={e => Common.validateDecValue(e.target.value, setCommValue)} />
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                            : null
                                                    }
                                                </Row>
                                            </>
                                    }
                                    <Row>
                                        <Col className="col-md-3 col-6">
                                            {/* <Badge className='handCursor' bg="primary" onClick={handleShowCommissionDetail}>View Commission Details</Badge> */}
                                            <Form.Check type='checkbox' checked={showCommissionDetail} onChange={e => setShowCommissionDetail(e.target.checked)} label='Commission Details' />
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addProduct()}>Add</Button>
                                            &nbsp;
                                            <Button variant='outline-secondary' size='sm' onClick={() => setKey("PAYMENT")} onKeyDown={switchToPaymentTab}>Payment -&gt;</Button>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Table responsive bordered striped>
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Product</th>
                                                    <th>Isd Code</th>
                                                    <th>Isd Name</th>
                                                    <th>Denomination</th>
                                                    <th>Quantity</th>
                                                    <th>Rate</th>
                                                    <th>Amount</th>
                                                    <th>USD Rate</th>
                                                    <th>USD Equivalent Amount</th>
                                                    {
                                                        showCommissionDetail &&
                                                        <>
                                                            <th>Agent</th>
                                                            <th>Commission Type</th>
                                                            <th>Commission</th>
                                                            <th>Commission Value</th>
                                                        </>
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    productList.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    scrMode === "Q" || item.delny === "N" ? null :
                                                                        <span onClick={() => deleteProduct(item.uniquekey)} className='colorThemeBlue pointer'>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </span>
                                                                }
                                                            </td>
                                                            <td>{item.prd_product}</td>
                                                            <td>{item.prd_isd}</td>
                                                            <td>{item.isd_name}</td>
                                                            <td>{item.prd_deno}</td>
                                                            <td>{item.prd_qty}</td>
                                                            <td>{item.prd_rate}</td>
                                                            <td>{item.prd_amount}</td>
                                                            <td>{item.prd_usd_rate}</td>
                                                            <td>{item.prd_usd_amount}</td>
                                                            {
                                                                showCommissionDetail &&
                                                                <>
                                                                    {
                                                                        item.prd_agent_group == "0" ?
                                                                            <td></td> :
                                                                            <td>{item.prd_agent_group + " " + item.prd_agent_ledger + " " + item.prd_agent_name}</td>
                                                                    }
                                                                    <td>{item.prd_commission_type === "P" ? "Paisa"
                                                                        : item.prd_commission_type === "R" ? "Percentage"
                                                                            : item.prd_commission_type === "F" ? "Flat" : ""}</td>
                                                                    <td>{item.prd_commission * 1 > 0 ? item.prd_commission : ""}</td>
                                                                    <td>{item.prd_commission_value * 1 > 0 ? item.prd_commission_value : ""}</td>
                                                                </>
                                                            }
                                                            {/* <td>{item.prd_prefix}</td>
                                                            <td>{item.prd_from}</td>
                                                            <td>{item.prd_to}</td> */}
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                                </Tab>
                                <Tab eventKey="PAYMENT" title="Payment">
                                    {/* <Row>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>Taxable Value: {pTaxableVal}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>SGST: {pSgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>IGST: {pIgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>CGST : {pCgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>UGST : {pUgst}</Form.Label>
                                        </Col>
                                        <Col className="col-md-2 col-4">
                                            <Form.Label>Round Off: {pRoundOff}</Form.Label>
                                        </Col>
                                    </Row> */}
                                    <Row>
                                        <Col className="col-md-3 col-6" style={{ display: "flex", alignItems: "center" }}>
                                            <Form.Group>

                                                <Form.Label>OtherCharges: &nbsp;</Form.Label>
                                                {/* <span> */}
                                                <Form.Control size='sm' placeholder='Other Charges' type='text'
                                                    maxLength={5}
                                                    value={pOtherCharges}
                                                    onChange={e => otherChargeChange(e.target.value)}
                                                    disabled={disableOtherCharge || scrMode === "Q"}
                                                />
                                                {/* </span> */}
                                            </Form.Group>

                                        </Col>
                                        {/* {userRight.add === '1' && */}
                                        <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Round Off: &nbsp;</Form.Label>
                                                <Form.Control size='sm' placeholder='Round Off' type='number'
                                                    maxLength={10}
                                                    value={pRoundOff}
                                                    onChange={e => roundOffHandler(e.target.value)}
                                                    disabled={scrMode === "Q" && +userRight.add === 1}
                                                />
                                            </Form.Group>
                                        </Col>
                                        {/* } */}
                                    </Row>
                                    <hr />
                                    <Row>
                                        <Col><h3>Payment Details</h3></Col>
                                    </Row>
                                    {
                                        scrMode === "Q" ? null
                                            :
                                            <>
                                                <Row>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Payment Type</Form.Label>
                                                            <Form.Select value={pdPaymentType} onChange={e => handlePaymentType(e.target.value)}
                                                            // onBlur={e => handlePaymentType(e.target.value)}
                                                            >
                                                                <option value="">Select</option>
                                                                {/* <option value="CH">Cash</option> */}
                                                                <option value="BN">Bank</option>
                                                                <option value="CQ">Cheque</option>
                                                                <option value="RC">Recievables</option>
                                                                {/* <option value="AP">Advance Paid</option>
                                                                <option value="AR">Advance Recieved</option> */}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Account<span className="colorThemeRed">*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions={false}
                                                                defaultOptions={false}
                                                                value={pdAccount}
                                                                getOptionLabel={e => e.label + ' '}
                                                                getOptionValue={e => e.id}
                                                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, ldgSrchType, sbLocationValue)} // location = 1 , 2
                                                                onInputChange={Picklist.handleInputChange}
                                                                onChange={handleAccountValue}
                                                                isDisabled={disablePaymentAccount}
                                                            >
                                                            </AsyncSelect>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        pdPaymentType !== "" ?
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Amount<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control placeholder='Amount' value={pdAmount} onChange={e => Common.validateDecValue(e.target.value, setPdAmount)} />
                                                                </Form.Group>
                                                            </Col> : null
                                                    }
                                                </Row>
                                                {
                                                    pdPaymentType === "BN" ?
                                                        <Row>
                                                            <Col className="col-md-12">
                                                                <Form.Group>
                                                                    <Form.Label>Reference No<span className="colorThemeRed">*</span></Form.Label>
                                                                    <Form.Control placeholder='Reference No' maxLength={255} value={pdChequeNum} onChange={e => Common.validateAlpNumSplValue(e.target.value, setPdChequeNum)} />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        : pdPaymentType === "CQ" ?
                                                            <Row>
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Group>
                                                                        <Form.Label>Cheque No<span className="colorThemeRed">*</span></Form.Label>
                                                                        <Form.Control placeholder='Cheque No' type='text' maxLength={10} value={pdChequeNum} onChange={e => Common.validateAlpNumValue(e.target.value, setPdChequeNum)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Group>
                                                                        <Form.Label>Bank Name<span className="colorThemeRed">*</span></Form.Label>
                                                                        <Form.Control placeholder='Bank Name' type='text' maxLength={50} value={chequeBankName} onChange={e => Common.validateAlpNumValue(e.target.value, setChequeBankName)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className="col-md-3 col-6">
                                                                    <Form.Group>
                                                                        <Form.Label>Cheque Date<span className="colorThemeRed">*</span></Form.Label>
                                                                        <DatePicker className="form-control"
                                                                            selected={chequeDate}
                                                                            onChange={(date) => setChequeDate(date)}
                                                                            dateFormat="dd/MM/yyyy"
                                                                            showYearDropdown
                                                                            showMonthDropdown
                                                                            useShortMonthInDropdown
                                                                            dropdownMode="select"
                                                                            peekNextMonth
                                                                            customInput={
                                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                            }
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                            : pdPaymentType === "RC" ?
                                                                <Row>
                                                                    <Col className='col-md-12'>
                                                                        <Form.Group>
                                                                            <Form.Label>Remark<span className="colorThemeRed">*</span></Form.Label>
                                                                            <Form.Control type="text" maxLength={255} placeholder='Remark' disabled={scrMode === "Q"} value={pdRemark} onChange={e => Common.validateAlpNumSplValue(e.target.value, setPdRemark)} />
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                : null
                                                }
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col>
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => addPayment()}>Add</Button>&nbsp;
                                                    </Col>
                                                </Row>
                                            </>
                                    }
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Table responsive striped bordered>
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Type</th>
                                                    <th>Group</th>
                                                    <th>Account</th>
                                                    <th>Name</th>
                                                    <th>Amount</th>
                                                    <th>Cheque/Reference No/Remark</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paymentData.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    scrMode !== "Q" ?
                                                                        <span className='colorThemeBlue pointer' onClick={() => deletePayment(item.uniquekey, item.delny)}>
                                                                            <FontAwesomeIcon icon={faTrash} />
                                                                        </span> : null
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    item.tp_payment_type === "BN"
                                                                        ? "Bank" : item.tp_payment_type === "CQ"
                                                                            ? "Cheque" : item.tp_payment_type === "CH"
                                                                                ? "Cash" : item.tp_payment_type === "RC"
                                                                                    ? "Receivables" : item.tp_payment_type === "PB"
                                                                                        ? "Payables" : item.tp_payment_type === "AP"
                                                                                            ? "Advance Paid" : item.tp_payment_type === "AR"
                                                                                                ? "Advance Received" : ""
                                                                }
                                                            </td>
                                                            <td>{item.tp_group}</td>
                                                            <td>{item.tp_account}</td>
                                                            <td>{item.mvli_ledger_name}</td>
                                                            <td>{item.tp_amount}</td>
                                                            <td>{item.tp_payment_type === "RC" ? item.tp_remark : item.tp_cheque}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </Row>
                                </Tab>
                            </Tabs>
                            <hr />
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' size='sm' className='buttonStyle' onClick={() => cancelConfirm()}>Back</Button>
                                    &nbsp;
                                    {
                                        (+userRight.edit === 1 && scrMode === 'Q' && cancelButtonView) ? <>
                                            <Button style={{ display: +isIrnGenerated === 1 && "none" }} variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                editData()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {
                                        (+userRight.edit === 1 && scrMode === 'E') || (+userRight.add === 1 && scrMode === 'A') ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData(false)}>Save</Button>
                                        </> : null
                                    }
                                    {/* {
                                        (userRight.query === "1") ? <>
                                            <Button variant='outline-success' size='sm' className='buttonStyle' onClick={() => print("D")}>With Deno</Button>&nbsp;
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => print("")}>Without Deno</Button>
                                        </> : null
                                    } */}
                                    {
                                        (+userRight.query === 1 && scrMode === "Q") ?
                                            <>
                                                {
                                                    +Common.Billprint === 1 &&
                                                    <>
                                                        <Button variant='outline-success' size='sm' className='buttonStyle divHide' onClick={() => print("D")}>With Deno</Button>&nbsp;
                                                        <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => print("")}>Without Deno</Button>&nbsp;
                                                    </>
                                                }
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                                {(+userRight.query === 1 && scrMode === 'Q') ? <>
                                                    <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                        btnActivityLog()}>Activity Log</Button>&nbsp;
                                                </> : null
                                                }
                                            </> : null
                                    }
                                    {
                                        scrMode === "Q" &&
                                        <Button variant="outline-secondary" className='buttonStyle' size="sm" onClick={() => addNewForm()}>Add New</Button>
                                    }
                                    {
                                        (scrMode === "Q" && +userRight.delete === 1) &&
                                        <>
                                            &nbsp;
                                            {+dateChangeRight?.query === 1 &&
                                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => changeDateModal()}>Date Change</Button>}
                                        </>
                                    }
                                    {
                                        (scrMode === "Q" && +userCancelBillRight.query === 1 && cancelButtonView) &&
                                        <>
                                            &nbsp;
                                            <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => handleCancelBill()}>Cancel Bill</Button>
                                        </>
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                        </>
                }
            </Container>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <Modal show={showMinMaxRateModal} size='xl' onHide={() => setShowMinMaxRateModal(false)} scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <Row>
                            <Col>
                                <span>MIN/MAX RATE CARD</span>
                                <span>&nbsp;</span>
                            </Col>
                        </Row>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Table striped responsive bordered>
                            <thead>
                                <tr>
                                    <th>ISD</th>
                                    <th> MINIMUM</th>
                                    <th>RATE</th>
                                    <th>MAXIMUM</th>
                                </tr>
                            </thead>
                            <tbody>
                                {minMaxRate.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.isd}</td>
                                        <td>{item.minsalerate}</td>
                                        <td>{item.salerate}</td>
                                        <td>{item.maxsalerate}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Row>
                </Modal.Body>
            </Modal>
            <span className="corner-span">{counter}</span>

            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />

            {/* <Tran_commission_view show={showCommissionDetail} onHide={() => setShowCommissionDetail(false)} productList={productList} /> */}

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <CancelDialog isOpen={msgBoxYNBillDelete} onYes={handleDeleteBill} onNo={(e) => setMsgBoxYNBillDelete(false)}>
                {msgTextYNBillDelete}
            </CancelDialog>
            <Dialog_IRN
                isOpen={isMsgBoxCancelBill}
                onYes={(e) => cancelBill()}
                onNo={(e) => setMsgBoxCancelBill(false)}
                text={msgTextCancelBill}
                checkLabel={irnCancelLabel}
                irnCancelDeclaration={irnCancelDeclaration}
                setIrnCancelDeclaration={setIrnCancelDeclaration}
                irnCancelReason={irnCancelReason}
                setIrnCancelReason={setIrnCancelReason}
                irnCancelReasonSelect={irnCancelReasonSelect}
                setIrnCancelReasonSelect={setIrnCancelReasonSelect}
            />

            <div>
                <Modal size='lg' show={showModal} onHide={() => setShowModal(false)} animation={false} centered>
                    <Modal.Body>
                        <>
                            <h4>{riskModalBoxText}</h4>
                            <Form.Group>
                                <Form.Label>Action Taken<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Reason" maxLength={499}
                                    value={acRemark}
                                    onChange={(e) => Common.validateAlpValue(e.target.value, setAcRemark)}
                                    autoComplete="off"
                                    required />
                            </Form.Group>
                        </>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-success" onClick={() => saveData(true)}>
                            Save
                        </Button>{' '}
                        <Button variant="outline-success" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            <Tran_date_change_modal openDateChangeModal={openDateChangeModal} setOpenDateChangeModal={setOpenDateChangeModal} changeDateObj={changeDateObj} setMsgBox={setMsgBox} setMsgText={setMsgText} />
            <Tran_stock_modal showStockModal={showStockModal} setShowStockModal={setShowStockModal} stockObj={stockObj} />
        </>
    )
}

export default Tran_sb
